import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            视频分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            涵盖电影、电视剧、综艺、动漫、纪录片等丰富内容，满足您的多样化观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 border border-background-200 hover:border-primary-400/40 transition-all duration-300 p-5 md:p-6 text-center cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-3 md:mb-4 rounded-full bg-primary-500/10 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-600 line-clamp-2">
                {cat.description}
              </p>
              <div className="mt-3 flex items-center justify-center gap-1 text-primary-500 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>浏览全部</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}